import React, { useEffect, useRef } from "react";
import { linksRouter } from "../../../config/RouterLink";
import { Link } from "react-router-dom";
//Antd
import { Col, Row, Typography } from "antd";

/**Ant-design icons */
import { LeftCircleOutlined } from "@ant-design/icons";
// import { useDispatch } from "react-redux";
// import { openModalLogin } from "../../../redux/aspirante/aspiranteDucks";

const { Text } = Typography;

export const CuentaDesactivadaPage = () => {
  // const dispatch = useDispatch();
  const isMounted = useRef(true);

  // useEffect(() => {
  //   dispatch(openModalLogin());

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  //useEffect que valida si el componente está montado en la App.
  useEffect(() => {
    return () => {
      isMounted.current = false; //Desmontar el componente
    };
  }, []);

  return (
    <>
      <div className="layout-content-public">
        <div style={{ marginBottom: 20, marginTop: 20 }}>
          <Link to={linksRouter.raiz} className="link">
            <LeftCircleOutlined /> Regresar
          </Link>
        </div>
        <div>
          <Row style={{ marginBottom: "10px" }}>
            <Col span={24}>
              <Text style={{ fontSize: "28px", fontWeight: 400 }}>
                Cuentas desactivadas
              </Text>
            </Col>
          </Row>
          <br />
          <Row>
            <Col span={20}>
              <Text style={{ fontSize: "26px" }}>¡UPS! </Text>
              <br />
              <br />

              <Text style={{ fontSize: "18px" }}>
                Actualmente tu cuenta se encuentra desactivada, para mayor
                atención te sugerimos ponerte en contacto con un administrador.
              </Text>

              <br />
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
